import { UPDATEDYNAMICFIELD_SUCCESS, UPDATEDYNAMICFIELD_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const updateDynamicFieldReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATEDYNAMICFIELD_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case UPDATEDYNAMICFIELD_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default updateDynamicFieldReducer;
